<template>
  <div class="works-com" v-if="dataList">
    <div class="wrapper">
      <div class="content">
        <div v-for="(item, index) in dataList" :key="'eval'+index" ref="box" class="contentbox">
          <div class="user-info evaluate-item">
            <works-show :item="item" @showPicture="showPicture" @showVideo="showVideo" @onVideoPlay="onVideoPlay">
              <slot name="workShow" :data="{item, index}">

              </slot>
            </works-show>
          </div>
        </div>
      </div>
    </div>
    <slot name="foot">

    </slot>
    <popup :style="{ width: '100%', backgroundColor: 'rgba(0,0,0,0.2)' }" v-model="show" class="show-box">
      <div v-if="imgList[0] && imgList.every(item => getFlieType(item) === 1)" >
        <swipe :show-indicators="false" @activeChange="changeIndex" :initialSwipe='imgIndex' :style="{ height: '100vh', width: '100vw' }" ref="swipeImg">
          <swipe-item v-for="(item, index) in imgList" :key="'img'+index"  @click="show = false" :style="{ display: 'flex', alignItems: 'center' }">
            <img :src="item" :style="{ width: '100%' }" alt="">
          </swipe-item>
        </swipe>
        <div class="curr-active">
            {{ activeIndex }} / {{ imgList.length }}
        </div>        
      </div>
      <div v-if="getFlieType(showContent) === 3 && show" :style="{ height: '100vh', width: '100vw', display: 'flex', alignItems: 'center' }"  @click="show = false">
        <video :src="showContent" class="show-content" autoplay loop/>
      </div>
    </popup>
  </div>
</template>

<script>
  import WorksShow from '@components/worksShow/WorksShow'

  import BScroll from 'better-scroll'
  import { Popup, Swipe, SwipeItem } from 'vant'
  import { getFlieType } from '@common'

  export default {
    name: 'worksCom',
    components: { 
      Popup,
      WorksShow,
      Swipe,
      SwipeItem
    },
    props: ['dataList'],
    data() {
      return {
        limit: 10,
        page: 1,
        show: false,
        imgList: [],
        showContent: '',
        videosLength: 0,
        scrollEndOnce: true,
        currindex: 0,
        commentData: null,
        imgIndex: 0,
        activeIndex: 1
      }
    },
    methods: {
      getFlieType(url) { //检测文件类型
        let type = getFlieType(url);
          if (type === 'image') { //图片
            return 1;
          }else if (type === 'radio') { //音乐
            return 2;
          }else if (type === 'video') { //视频
            return 3;
          }else {
            return 0;
          }
      },
      showPicture(data) { //展示图片
        this.showContent = '';
        this.show = true;
        this.imgList = data.path;
        this.imgIndex = data.index;
        this.$emit('showPicture', data);
      },
      showVideo(data) { //展示视频
        this.imgList.splice(0, this.imgList.length);
        this.show = true;
        this.showContent = data.path;
        let index = this.passIdOfIndex(data.id);
        if (index !== -1) {
          this.$el.querySelectorAll('.contentbox')[index].querySelector('video').pause();
        }
      },
      passIdOfIndex(id) { //id获取索引
        return this.dataList.findIndex(item => Number(item.id) === Number(id));
      },
      changeIndex(value) {
        this.activeIndex = value === -1 ? this.imgList.length : (value === this.imgList.length ? 1 : value+1);
      },
      onVideoPlay(data) { //播放器播放 //emit
        this.$emit("onVideoPlay", data);
      },
    },
    mounted() {

      /**
       * scroll
       */
      this.scroll = new BScroll('.wrapper', {
        pullUpLoad: true,
        click: true,
        snapThreshold: 0.5,
        bounceTime: 1000
      });
      this.$emit('ScrollCreate', this.scroll);
      this.scroll.on('pullingUp', () => {
        this.scroll.refresh();
        this.$emit('pullingUp');
        if (this.scrollEndOnce) {
          this.scrollEndOnce = false;
          this.scroll.on('scrollEnd', res => {
            let videos = this.$el.querySelectorAll('video');
            let play_once = true;
            if (videos && videos.length) {
              this.$refs.box.forEach(item => {
                let targe_video = item.querySelector('video');
                if (targe_video) {
                  let view_diffHeight = this.$el.offsetHeight - (item.offsetHeight/2);
                  if ((item.offsetTop - view_diffHeight) < 0) {
                    if (res.y < Math.abs(item.offsetTop - view_diffHeight) && Math.abs(res.y) <= Math.abs(item.offsetTop + (item.offsetHeight/3))) {
                      if (play_once) {
                        targe_video.play();
                        play_once = false;
                      }
                    }else {
                      targe_video.pause();
                    }
                  }else {                
                    if (Math.abs(res.y) > Math.abs(item.offsetTop - view_diffHeight) && Math.abs(res.y) <= Math.abs(item.offsetTop + (item.offsetHeight/3))) {
                      if (play_once) {
                        targe_video.play();
                        play_once = false;
                      }
                    }else {
                      targe_video.pause();
                    }
                  }
                }
              });
            }
          });          
        }
      });
    },
  }
</script>

<style scoped>
  .works-com {
    width: 100%;
    height: 100%;
    position: relative;
    overflow-y: scroll;
  }
    .wrapper {
      height: 100vh;
      overflow: hidden;
    }
      .content {
        padding-bottom: 2rem;
      }
        .evaluate-item {
          width: 100%;
          background-color: white;
          border-radius: 0.15rem;
          margin-top: 0.3rem;
        }
          .user-info {
            padding: 0.3rem;
            width: 100%;
          }
        .show-box {
          display: flex;
          align-items: center;
        }
        .show-content {
          width: 100%;
        } 
      .curr-active {
        position: absolute;
        color: white;
        bottom: 1rem;
        right: 0.2rem;
      }
</style>